module.exports = __webpack_public_path__ + "static/img/c5.2552242.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c5.png
// module id = c7CH
// module chunks = 0